<template>
  <ol class="breadcrumb mb-0">
    <li class="breadcrumb-item">
      <router-link :to="{ name: 'StartPage' }">Home</router-link>
    </li>
    <li class="breadcrumb-item" v-for="(item, index) in validList" :key="index">
      <span class="active text-capitalize">{{ item.replace('-', ' ').replace('-', ' ') }}</span>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    validList () {
      return this.list.filter(item => this.isValid(item))
    }
  },
  methods: {
    isValid (item) {
      if (parseInt(item.length) > 1) return true
      else return false
    },
    isLast (index) {
      return index === this.list.length - 1
    },
    showName (item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
      }
      if (item.name) {
        item = item.name
      }
      return item.replace('-', ' ')
    }
  }
}
</script>

<style scoped>
.breadcrumb {
  position: fixed;
  width: 100%;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/containers/layout/Breadcrumb.vue